import { clearAuthCookies } from '../../utils/api';

function LogOut() {
  clearAuthCookies();
  window.location.href = '/sign-in';
}

export default LogOut;